
// refresh-cart-drawer-subtotal.js
// Updates the mini cart subtotal using Shopify's /cart.js response.
// Safe to include multiple times; it only defines a single function and listeners.

if (!window.__hpoSubtotalPatched) {
  window.__hpoSubtotalPatched = true;

  async function refreshCartDrawerSubtotal() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) return;
      const cart = await res.json();
      var el = document.querySelector('#CartDrawer-Subtotal');
      if (el && cart && typeof cart.total_price === 'number') {
        el.textContent = (cart.total_price/100).toLocaleString('sv-SE', {
          style: 'currency', currency: 'SEK'
        });
      }
    } catch (e) { /* noop */ }
  }

  // Common triggers across themes
  document.addEventListener('cart:updated', refreshCartDrawerSubtotal);
  document.addEventListener('drawer:open', refreshCartDrawerSubtotal);

  document.addEventListener('change', function(e) {
    if (e.target && e.target.closest('.cart-drawer, .mini-cart')) {
      setTimeout(refreshCartDrawerSubtotal, 250);
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest('[name="add"][type="submit"], [data-ajax-add-to-cart], .quantity__button')) {
      setTimeout(refreshCartDrawerSubtotal, 400);
    }
  });
}
// Fallback: observera förändringar i cart drawer DOM
try {
  var drawer = document.querySelector('.cart-drawer');
  if (drawer && !window.__subtotalObserver) {
    window.__subtotalObserver = new MutationObserver(function() {
      setTimeout(refreshCartDrawerSubtotal, 200);
    });
    window.__subtotalObserver.observe(drawer, { childList: true, subtree: true });
  }
} catch(e) {}

